<template>
  <div class="customer" v-if="customer">
    <div class="avatar">
      <image-loader
        :src="customer.media.url"
        width="60px"
        height="60px" />
    </div>
    <div class="name" v-if="customer.nickname">{{ customer.nickname }}</div>
    <div class="name" v-else>{{ customer.fname }} {{ customer.lname }}</div>
    <div class="email" v-if="customer.email">{{ customer.email }}</div>
    <dropdown :id="id"></dropdown>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import dropdown from '@/components/customers/customer-dropdown.vue'

export default {
  name: 'customer-card',

  props: {
    id: {
      type: String,
      required: true
    }
  },
  components: {
    dropdown
  },

  computed: {
    ...mapGetters('customers', {
      getById: 'getById'
    }),

    customer () {
      return this.getById(this.id)
    }
  },

  watch: {
    site: {
      handler: 'init',
      immediate: true
    }
  },

  methods: {
    ...mapActions('customers', ['loadCustomerById']),

    init () {
      if (!this.customer) {
        this.loadCustomerById({id: this.id})
      }
    }
  }
}

</script>

<style lang="scss" scoped>
.fade-enter-active {
  transition: opacity 800ms ease-in-out;
}

.fade-enter-to {
  opacity: 1;
}

.fade-enter {
  opacity: 0;
}
  .customer {
    align-items: center;
    font-size: 14px;
    display: grid;
    padding: 0 0 12px 0;
    border-bottom: 1px solid #dedede;
    grid-template-columns: 80px 1fr 24px;
    grid-template-rows: 1fr 1fr;
    grid-template-areas:
        "avatar name actions"
        "avatar email actions"
    ;
    .name {
      font-weight: 600;
      grid-area: name;
    }
    .avatar {
      grid-area: avatar;

      img {
        height: 60px;
        width: 60px;
        border-radius: 4px;
        -webkit-animation-duration: 1s;
        -webkit-animation-fill-mode: forwards;
        -webkit-animation-iteration-count: infinite;
        -webkit-animation-name: placeholderSkeleton;
        -webkit-animation-timing-function: linear;
        background: #f6f7f8;
        background-image: -webkit-gradient(linear, left center, right center, from(#f6f7f8), color-stop(.2, #edeef1), color-stop(.4, #f6f7f8), to(#f6f7f8));
        background-image: -webkit-linear-gradient(left, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);
        background-repeat: no-repeat;
        position: relative;
      }

    }
    .email {
      grid-area: email;

    }
    .actions {
      grid-area: actions;
    }
  }

  @-webkit-keyframes placeholderSkeleton {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/customers/customer-card.vue